export default __webpack_public_path__ + "static/media/expense-16px.34e6304f.svg";